/**
 * @author jzhu 2020-6-11
 */
import React, { Component } from 'react'
import { component_tool } from '../../../tool'
let { WizButton, WizCard, WizAntdForm, WizRow, WizCol, WizForm } = component_tool
import { WizAuthority } from '../../common'
import './index.less'

class WizAuthorityDemo extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  _onSubmit = (values, record) => {
    console.log('WizAuthorityDemo values ---> ', values)
    console.log('WizAuthorityDemo record ---> ', record)
  }

  _renderAuthority = (initialValue) => {
    let formProps = {
      ref: 'form',
      columns: [
        {
          title: '数据权限1',
          name: 'dataAuth1',
          formItem: {
            type: 'diy',
            diy: WizAuthority,
            //wizAuthorityProps
            keys: ['orgIds', 'positionIds', 'positionCategoryIds', 'personIds']
          }
        },
        {
          title: '数据权限2',
          name: 'dataAuth2',
          formItem: {
            type: 'diy',
            diy: WizAuthority,
            //wizAuthorityProps
            mode: 'Form',
            // classname: 'demo-authority',
            keys: ['orgIds', 'positionCategoryIds', 'personIds']
          }
        },
        {
          title: '数据权限3',
          name: 'dataAuth3',
          formItem: {
            type: 'diy',
            diy: WizAuthority,
            //wizAuthorityProps
            showBlock: false,
            keys: ['orgIds', 'positionIds', 'positionCategoryIds', 'personIds']
          }
        }
      ],
      record: {
        dataAuth1: { ...initialValue },
        dataAuth2: { ...initialValue },
        dataAuth3: { ...initialValue }
      },
      onSubmit: this._onSubmit,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 15 }
      }
    }
    return (
      <WizCard title={'数据权限选择'} >
        <WizForm {...formProps} />
      </WizCard>
    )
  }

  _renderShow = (initialValue) => {
    return (
      <WizCard title={'数据权限展示'} >
        <WizAuthority value={initialValue} mode='Show' />
      </WizCard>
    )
  }


  handleSubmit = e => {
    this.props.form && this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        console.log('WizAuthorityDemo values of mode:Form: ', values)
      }
    })
  }
  
  handleReset = () => {
    this.props.form && this.props.form.resetFields()
  }

  _renderForm = (initialValue) => {
    let { form } = this.props
    return (
      <WizCard title={'数据权限表单'} >
        <WizAntdForm onSubmit={this.handleSubmit}>
          {
            form ? form.getFieldDecorator('dataAuth4', { initialValue: initialValue })(
              <WizAuthority value={initialValue} mode='Form' keys={['orgIds', 'positionIds', 'personIds']} />
            )
              :
              <WizAuthority value={initialValue} mode='Form' keys={['orgIds', 'positionIds', 'personIds']} />
          }
          <WizAntdForm.Item wrapperCol={{ span: 12, offset: 6 }}>
            <WizRow>
              <WizCol span={24} style={{ textAlign: 'center' }}>
                <WizButton type='primary' htmlType='submit'>
                  保存
              </WizButton>
                <WizButton style={{ marginLeft: 20 }} onClick={this.handleReset}>
                  重置
              </WizButton>
              </WizCol>
            </WizRow>
          </WizAntdForm.Item>
        </WizAntdForm>
      </WizCard>
    )
  }

  render() {
    let initialValue = {
      orgIds: [{ id: 89, name: 'yuyuyu' },{ id: 89, name: 'yuyuyu' },{ id: 89, name: 'yuyuyu' }],
      positionIds: [{ id: 81, name: '213131' }],
      positionCategoryIds: [{ id: 42, name: '2020Arieltest' }],
      personIds: [{ id: '459924dca47b90308c87296327c8b400', userName: 'test031715d01', fullName: 'test0317150d13' }],
      message: ['受众人数 11人', '已考人数 0人']
    }
    return (
      <>
        {this._renderAuthority(initialValue)}
        {this._renderShow(initialValue)}
        {this._renderForm(initialValue)}
      </>
    )
  }
}

export default WizAntdForm.create()(WizAuthorityDemo)